/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/named */

import Link from 'next/link'
import assetLoader from '@utils/internalImageLoader'
import Image from 'next/image'
import styles from './styles/topic.module.scss'
import { cleanPathname } from '../common/urlValidation'

const Topic = ({ src, name, alt, url, width, height }) => (
  <Link href={cleanPathname(`/articles/${url}/`)}>
    <div className={styles.TopicsContainer}>
      <div className={styles.TopicIconWrapper}>
        {src ? <Image src={src} alt={alt} width={width} height={height} layout="fixed" /> : null}
      </div>
      <p className={styles.TopicName}>{name}</p>
      <div className={styles.IconWrap}>
        <Image
          src={`${assetLoader()}/images/arrow-right.svg`}
          alt="Icon"
          width="20"
          height="20"
          className="icon"
          layout="fixed"
        />
      </div>
    </div>
  </Link>
)

export default Topic
